import { useEffect, useState } from 'react';

const STORAGE_KEY = 'tuneamplifier_google_consent_v1';

function updateGoogleConsent(granted) {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag('consent', 'update', {
    ad_storage: granted ? 'granted' : 'denied',
    ad_user_data: granted ? 'granted' : 'denied',
    ad_personalization: granted ? 'granted' : 'denied',
    analytics_storage: granted ? 'granted' : 'denied',
  });
}

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);

      if (saved === 'accepted') {
        updateGoogleConsent(true);
      } else if (saved === 'rejected') {
        updateGoogleConsent(false);
      } else {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (accepted) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        accepted ? 'accepted' : 'rejected',
      );
    } catch {
      // The Google consent update still applies for this session.
    }

    updateGoogleConsent(accepted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie and advertising consent"
      className="fixed inset-x-0 bottom-0 z-[9999] px-4 pb-4 pointer-events-none"
    >
      <div className="pointer-events-auto mx-auto max-w-5xl rounded-2xl border border-zinc-700 bg-zinc-950/95 p-4 shadow-2xl backdrop-blur-md">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="min-w-0">
            <div className="font-display text-sm text-zinc-100 mb-1">
              Privacy & cookies
            </div>
            <p className="text-xs leading-5 text-zinc-400">
              TuneAmplifier uses Google advertising and measurement technology
              to understand website usage and measure advertising performance.
              You can accept or decline optional advertising and analytics
              storage. Essential functionality remains available either way.
            </p>
          </div>

          <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
            <button
              type="button"
              onClick={() => choose(false)}
              className="rounded-full border border-zinc-700 px-4 py-2 text-xs font-mono text-zinc-300 transition-colors hover:border-zinc-500 hover:text-white"
            >
              Decline
            </button>

            <button
              type="button"
              onClick={() => choose(true)}
              className="rounded-full bg-[#ccff00] px-4 py-2 text-xs font-mono font-semibold text-black transition-opacity hover:opacity-90"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
